export default (urlParameters) => {
  return {
    wind_graph: {
      show_data_fields_menu: false,
      show_nearby_spots: false,
      show_virtual: false,
    },
    pro_forecast: {
      id: null,
    }
  }
}